<template>
  <search-popup
    :show="show"
    :placeholder="$route.params.space === 'frequent' ? $t('file.searchInAll') : $t('file.search')"
    v-model="searchText"
    @close-search="onClose"
  >
    <tabs v-if="!isOpenIndex && $route.params.space !== 'frequent'" :items="filterItems" v-model="searchIn" @change="handleSearchInClick" />
    <file-list
      v-show="searchText && searchText.trim()"
      :class="['search-list', $route.params.module === 'select_files' && 'open-search-list']"
      :searchInFolder="searchIn === 'current'"
      :selectedFiles="selectedFiles"
      scenario="search"
      @item-select-toggle="toggleSelect"
    />
  </search-popup>
</template>
<script>
import {i18n} from '@/utils/i18n'
import FileList from './FileList'
import SearchPopup from '../utils/SearchPopup'
import Tabs from '../utils/Tabs'
export default {
  name: 'SearchView',
  i18n,
  components: {
    FileList,
    SearchPopup,
    Tabs
  },
  props: {
    show: Boolean,
    selectedFiles: Array,
    isOpenIndex: Boolean
  },
  data () {
    return {
      searchText: this.$route.query.search_text,
      searchIn: this.$route.query.search_in || 'current',
      filterItems: [{id: 'current', name: i18n.t('search.currentFolder')}, {id: 'all', name: i18n.t('search.allFile')}]
    }
  },
  watch: {
    $route (to) {
      this.searchIn = to.query.search_in || 'current'
    },
    searchText (text) {
      this.$router.replace({ query: { ...this.$route.query, search_text: text } })
    }
  },
  methods: {
    onClose () {
      this.$router.go(-1)
    },
    handleSearchInClick (searchIn/* , name */) {
      this.$router.replace({ query: { ...this.$route.query, search_in: searchIn } })
    },
    toggleSelect (item) {
      this.$emit('item-select-toggle', item)
    }
  }
}
</script>
<style lang="postcss">

</style>
